/* ============
 * Getters for the Management protocol template module
 * ============
 *
 * The getters that are available on the
 * Management protocol template module.
 */
import { clone } from '@/utils/object';

const getManagementProtocolTemplate = state => clone(state.managementProtocolTemplate);
const getProtocolList = state => clone(state.protocolList);
const getLoading = state => clone(state.loading);

export default {
  getManagementProtocolTemplate,
  getProtocolList,
  getLoading
};
